// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1767":"26d34c040d839221","6140":"6956205e6bea30f4"}[chunkId] + ".js";
};